export const LATITUDE = 'locationLat';
export const LONGITUDE = 'locationLon';
export const PLATFORM_VERSION = 'platformVersion';
export const COMMON_DATA_KEYS = {
  [LATITUDE]: LATITUDE,
  [LONGITUDE]: LONGITUDE,
  [PLATFORM_VERSION]: PLATFORM_VERSION,
};
